import { useState } from "react";
import "./CampaignBillboardTable.css";
import { ReactComponent as Delete } from "../../../../assests/delete_icon.svg";
import { ReactComponent as EyeIcon } from "../../../../assests/eye-icon.svg";
import { ReactComponent as DownloadIcon } from "../../../../assests/download-icon.svg";

import { useMediaQuery } from "react-responsive";
import {
  Row,
  Col,
  Checkbox,
  Typography,
  Image,
  message,
  Space,
  Button,
  Tooltip,
  Spin,
} from "../../../common/utils/antd-imports/AntdImports";
import { API_BASE_URL_IMAGE } from "../../../../services/common";
import {
  CopyOutlined,
  MinusOutlined,
  PlusOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { updateProductQty } from "../../../../store/thunks/buyer-thunks/BuyerThunks";
import { useNavigate } from "react-router-dom";
import ProductModalPopUp from "../../../modal/product-detail-modal/ProductModalPopUp";
import "../../../../main.css";
import { formatToUSCurrency, handleCopy } from "../../utils/Utils";
import DeleteCamapign from "../../../modal/delete-campaign/DeleteCampaign";
import { ReactComponent as LocationIcon } from "../../../../assests/location-grey-icon.svg";
import { ReactComponent as Calendar } from "../../../../assests/date-icon-grey.svg";
import { ReactComponent as Arrow } from "../../../../assests/Icon_transform.svg";
import {
  addBreadcrumb,
  setBreadcrumbs,
} from "../../../../store/slices/common-slice/bread-crumbs/BreadCrumbSlice";
import { setIsProductPopUp } from "../../../../store/slices/common-slice/product-details-action-items/productDetailsActionItemslice";
import "../../../../styles/GlobalStyle.css";
import ReusableModal from "../../../modal/re-usable-modal/ReusableModal";
import { getDownloadSigned } from "../../../../store/thunks/common-thunks/commonThunk";
const { Title, Text } = Typography;

const CampaignBillBoardsTable = ({
  offerTooltip,
  hideButton,
  campaignInfo,
  campaignId,
  campaignName,
  campaignStatus,
  getToolTipContent,
  isCustomTermsApplied,
  deleteProducts,
  setDeleteProducts,
  offerList,
  setSelectAll,
}) => {
  const isMobile = useMediaQuery({ maxWidth: 550 });
  const [selectedProduct, setSelectedProduct] = useState("");
  const [deleteCampaignModal, setDeleteCampaignModal] = useState();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [productPrice, setProductPrice] = useState(0);
  const { isQuantityLoading } = useSelector((state) => state.buyerCampaigns);
  const isSmall = useMediaQuery({ maxWidth: 768 });
  const [isActionModal, setIsActionModal] = useState(false);
  const [assetActionType, setAssetActionType] = useState(null);
  const [selectedMoveProduct, setSelectedMoveProduct] = useState(null);
  const formatDate = (timestamp) => {
    if (!timestamp) return "Invalid date";
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const parts = timestamp.split("-");
    if (parts.length !== 3) return "Invalid date format";
    const [year, month, day] = parts;
    return `${parseInt(day)} ${months[parseInt(month) - 1]} ${year}`;
  };
  const formatSize = (value) => {
    return value
      .replace(" feet", "'") // Convert feet to '
      .replace(" Line Inches", '"') // Convert inches to "
      .replace(" pixels", " px"); // Convert pixels to px
  };
  const handleAddQuantity = (product) => {
    const currentCount = product?.quantity || 1;
    if (currentCount < product?.available_quantity) {
      const payload = {
        campaign_id: campaignId,
        booking_id: product?.productbookingid,
        product_id: product?.product_id,
        quantity: Number(currentCount) + 1,
        dates: [
          { startDate: product?.booked_from, endDate: product?.booked_to },
        ],
      };
      dispatch(updateProductQty(payload));
    } else {
      message.error("Limit has been reached");
    }
  };

  const handleRemoveQuantity = (product) => {
    const currentCount = product?.quantity || 1;
    const payload = {
      campaign_id: campaignId,
      booking_id: product?.productbookingid,
      product_id: product?.product_id,
      quantity: Number(currentCount) - 1 < 1 ? 1 : Number(currentCount) - 1,
      dates: [{ startDate: product?.booked_from, endDate: product?.booked_to }],
    };
    dispatch(updateProductQty(payload));
  };
  const addProductNowBtn = (
    <Button
      className={`add-product-campaign ${
        hideButton ||
        offerTooltip ||
        campaignStatus === 600 ||
        isCustomTermsApplied
          ? "disable-button"
          : "pointer"
      }`}
    >
      <Text
        className="add-product-campaign-txt"
        onClick={() => {
          if (!restrictClick()) handleAddProduct();
        }}
      >
        Add Product Now
      </Text>
    </Button>
  );
  const restrictClick = () => {
    if (
      hideButton ||
      offerTooltip ||
      campaignStatus === 600 ||
      campaignStatus == 700 ||
      campaignStatus === 800 ||
      campaignStatus === 1000 ||
      campaignStatus === 1200
    )
      return true;
    else return false;
  };
  const handleDeleteProduct = (campaignId, product, price) => {
    setProductPrice(price?.toFixed(2));
    setSelectedProduct(product);
    setDeleteCampaignModal(true);
  };
  const handleAddProduct = () => {
    localStorage.setItem("campaignId", campaignId);
    localStorage.setItem("CampaignName", campaignName);
    dispatch(
      addBreadcrumb([
        { title: "Home", path: "/" },
        { title: "Products", path: "/buyer/products" },
      ]),
    );
    navigate("/buyer/products", { state: { campaignId: campaignId } });
  };
  const handleCheckboxChange = (e, product) => {
    const checked = e.target.checked;
    setDeleteProducts((prev) => {
      const updated = checked
        ? prev.includes(product?.id)
          ? prev
          : [...prev, product?.id]
        : prev?.filter((id) => id !== product.id);
      setSelectAll(
        !!campaignInfo?.length &&
          campaignInfo.every((item) => updated.includes(item?.id)),
      );

      return updated;
    });
  };
  const offerStatusLabels = {
    10: "Offer Sent",
    20: "Offer Accepted",
    30: "Offer Accepted",
    40: "Offer Rejected",
    50: "Offer Rejected",
  };
  const offerIndex = offerList?.length === 2 ? 1 : 0;
  const offerStatus = offerList?.[offerIndex]?.status;
  const badgeClass =
    offerStatus === 20 || offerStatus === 30
      ? "available-oval-shape-badge offer-oval-shape-badge-width"
      : offerStatus === 40 || offerStatus === 50
        ? "payment-term-upfront offer-oval-shape-badge-width"
        : "offer-oval-shape-badge offer-oval-shape-badge-width";
  const handleMoveProduct = (product) => {
    setSelectedProduct(product);
    setSelectedMoveProduct(product);
    setAssetActionType("Move");
    setIsActionModal(true);
  };
  return (
    <>
      <div>
        {campaignInfo?.length && campaignInfo?.length > 0 ? (
          <>
            <div>
              {campaignInfo?.length &&
                campaignInfo?.map((product, index) => {
                  const isTermsRecordApproved =
                    product?.terms_record_approval == 2;
                  return (
                    <div
                      className="billBoards-table common-card-styles"
                      key={index}
                    >
                      <>
                        <div style={{ overflowX: "auto" }}>
                          <div className="campaign-billboard-main-div ">
                            <Row
                              gutter={[16, 16]}
                              align="middle"
                              wrap
                              className="campaign-product-row "
                              style={{
                                width: "100%",
                                justifyContent: "space-between",
                                padding: "0px",
                              }}
                            >
                              {" "}
                              <Col className="re-designed-product-col">
                                <div className="billboard-image-container re-designed-image-container">
                                  {restrictClick() ? (
                                    <Tooltip title={getToolTipContent}>
                                      <Checkbox
                                        className="billboard-image-checkbox common-checkbox-black"
                                        checked={
                                          deleteProducts?.includes(
                                            product?.id,
                                          ) || false
                                        }
                                        onChange={(e) =>
                                          handleCheckboxChange(e, product)
                                        }
                                        disabled
                                      />
                                    </Tooltip>
                                  ) : (
                                    <Checkbox
                                      className="billboard-image-checkbox common-checkbox-black"
                                      checked={
                                        deleteProducts.includes(product?.id) ||
                                        false
                                      }
                                      onChange={(e) =>
                                        handleCheckboxChange(e, product)
                                      }
                                    />
                                  )}
                                  <Image
                                    className="billboards-image"
                                    src={
                                      `${API_BASE_URL_IMAGE}` +
                                      product?.image?.[0]
                                    }
                                    preview={false}
                                    alt="Product"
                                  />
                                </div>
                                <Col className="campaign-details-page-alignment-col">
                                  <>
                                    <div className="campaign-details-page-alignment">
                                      <div className="product-copy-text-field">
                                        <span className="campaign-overview-header common-data-labels-grey">
                                          {product?.siteNo}
                                        </span>
                                        <CopyOutlined
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            handleCopy(product?.siteNo);
                                          }}
                                          className="copy-icon"
                                        />
                                      </div>

                                      <div className="product-copy-text-field">
                                        <Tooltip
                                          styles={{
                                            body: {
                                              color: "#fff",
                                              backgroundColor: "#000",
                                            },
                                          }}
                                          title={
                                            <pre
                                              style={{
                                                margin: 0,
                                                textWrap: "auto",
                                              }}
                                              className="tooltip-product-card"
                                            >
                                              {product?.title}
                                            </pre>
                                          }
                                        >
                                          <span className=" common-data-value-black">
                                            {product?.title}
                                          </span>
                                          <CopyOutlined
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              handleCopy(product?.title);
                                            }}
                                            className="copy-icon"
                                          />
                                        </Tooltip>
                                      </div>
                                    </div>
                                    <div className="campaign-details-page-alignment location-grey-container">
                                      <LocationIcon />
                                      <Tooltip
                                        title={
                                          <pre
                                            style={{
                                              margin: 0,
                                              textWrap: "auto",
                                            }}
                                          >
                                            {[
                                              product?.area_name,
                                              product?.city_name,
                                              product?.state_name,
                                            ]
                                              .filter(Boolean)
                                              .join(", ")}
                                          </pre>
                                        }
                                      >
                                        <Title className=" truncate location-grey-text-12">
                                          {[
                                            product?.area_name,
                                            product?.city_name,
                                            product?.state_name,
                                          ]
                                            ?.filter(Boolean)
                                            ?.join(", ")}
                                        </Title>
                                      </Tooltip>
                                    </div>
                                    <div className="campaign-details-page-alignment location-grey-container">
                                      <Title className=" truncate location-grey-text-12">
                                        <div
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "5px",
                                          }}
                                          className="campaign-status-actions-row"
                                        >
                                          <Calendar className="margin-style" />
                                          {formatDate(
                                            product?.booked_from,
                                          )}{" "}
                                          <Arrow
                                            className="campaign-icons campaign-overview-icons"
                                            style={{
                                              width: "16px",
                                              height: "16px",
                                            }}
                                          />
                                          {formatDate(product?.booked_to)}{" "}
                                        </div>
                                      </Title>
                                    </div>
                                    <Text
                                      className={`move-product-text ${restrictClick() ? "disabled-opacity" : ""}`}
                                      onClick={() => {
                                        if (restrictClick()) {
                                          return;
                                        }
                                        handleMoveProduct(product);
                                      }}
                                    >
                                      Move to Another Campaign
                                    </Text>
                                    {product?.docusign_sign_status === 1 && (
                                      <Text
                                        // className="view-io-download-div"
                                        className={`move-product-text ${product?.payment_status === 2 ? "disabled-opacity" : ""}`}
                                        style={{
                                          cursor: "pointer",
                                          textDecoration: "underline",
                                          marginLeft: "10px",
                                        }}
                                        onClick={() => {
                                          product?.docusign_sign_status === 1 &&
                                            dispatch(
                                              getDownloadSigned({
                                                envelope_id:
                                                  product?.envelope_id,
                                              }),
                                            );
                                        }}
                                      >
                                        DownloadIO
                                      </Text>
                                    )}
                                  </>
                                </Col>
                              </Col>
                              {/* Main Details */}
                              <Col className="product-available-offer-action-col">
                                <div
                                  className="campaign-price-actions-div"
                                  style={{ padding: "0px", gap: "10px" }}
                                >
                                  <div className="re-designed-campaign-price-actions-div">
                                    <div
                                      className={`available-oval-shape-badge ${
                                        product?.sold_status !== 1
                                          ? "available"
                                          : "sold-out"
                                      }`}
                                    >
                                      {product?.sold_status === 1 ? (
                                        <span>Sold Out</span>
                                      ) : (
                                        <span>Available</span>
                                      )}
                                    </div>
                                    {offerStatus && (
                                      <span className={badgeClass}>
                                        {offerStatusLabels[offerStatus] ||
                                          "Unknown"}
                                      </span>
                                    )}

                                    {restrictClick() ? (
                                      <Tooltip title={getToolTipContent}>
                                        <Delete
                                          style={{
                                            color: restrictClick()
                                              ? "#808080"
                                              : "#d2042d",
                                            marginTop: "10px",
                                            marginLeft: "10px",
                                          }}
                                          onClick={() => {
                                            if (restrictClick()) {
                                              return;
                                            }
                                            handleDeleteProduct(
                                              campaignId,
                                              product,
                                              (product?.price || 0) *
                                                (product?.quantity || 0) +
                                                (product?.tax_percentage_amount ||
                                                  0) +
                                                (product?.install_production_cost ||
                                                  0),
                                            );
                                          }}
                                          className="campaign-action-icons "
                                        />
                                      </Tooltip>
                                    ) : (
                                      <Delete
                                        style={{
                                          color: restrictClick()
                                            ? "#808080"
                                            : "#d2042d",
                                          marginTop: "10px",
                                          marginLeft: "10px",
                                        }}
                                        onClick={() =>
                                          handleDeleteProduct(
                                            campaignId,
                                            product,
                                            (product?.price || 0) *
                                              (product?.quantity || 0) +
                                              (product?.tax_percentage_amount ||
                                                0) +
                                              (product?.install_production_cost ||
                                                0),
                                          )
                                        }
                                        className="campaign-action-icons "
                                      />
                                    )}
                                  </div>
                                  <div className="campaign-total-price-section">
                                    <span className="campaign-overview-header grey-color-text-99a1af-11">
                                      Total Price
                                    </span>
                                    <Title className="common-price-value-text-color-red-20">
                                      {formatToUSCurrency(
                                        parseFloat(
                                          (product?.price || 0) *
                                            (product?.quantity || 1) +
                                            product?.tax_percentage_amount +
                                            product?.install_production_cost,
                                        ).toFixed(2),
                                      )}
                                    </Title>
                                  </div>

                                  {restrictClick() ? (
                                    <Tooltip title={getToolTipContent}>
                                      <div
                                        className={`${
                                          hideButton ||
                                          offerTooltip ||
                                          campaignStatus > 100 ||
                                          !isTermsRecordApproved
                                            ? "disable-button"
                                            : "pointer"
                                        }`}
                                      >
                                        <div className="campaign-billboard-add-section campaign-billboard-add-section-div">
                                          <Tooltip
                                            title={
                                              product?.quantity == 1
                                                ? "Product count cannot be less than 1"
                                                : ""
                                            }
                                          >
                                            <Button
                                              shape="circle"
                                              icon={<MinusOutlined />}
                                              className={`border-radios-color-grey ${
                                                product?.quantity == 1 ||
                                                !isTermsRecordApproved
                                                  ? "disable-button"
                                                  : ""
                                              }`}
                                              size="small"
                                              onClick={() => {
                                                if (
                                                  (!restrictClick() &&
                                                    product?.quantity > 1) ||
                                                  !isTermsRecordApproved
                                                ) {
                                                  handleRemoveQuantity(product);
                                                }
                                              }}
                                              disabled={
                                                restrictClick() ||
                                                !isTermsRecordApproved
                                              }
                                            />
                                          </Tooltip>
                                          <span className="common-action-items-text-black-14">
                                            {product?.quantity || 1}
                                          </span>
                                          <Button
                                            shape="circle"
                                            size="small"
                                            icon={<PlusOutlined />}
                                            disabled={
                                              product?.quantity >=
                                                product?.available_quantity ||
                                              restrictClick() ||
                                              !isTermsRecordApproved
                                            }
                                            onClick={() =>
                                              handleAddQuantity(product)
                                            }
                                            className="border-radios-color-grey"
                                          />
                                        </div>
                                      </div>
                                    </Tooltip>
                                  ) : (
                                    <>
                                      <div
                                        className={`${
                                          restrictClick() ||
                                          !isTermsRecordApproved
                                            ? "disable-button"
                                            : "pointer"
                                        }`}
                                      >
                                        <div className="campaign-quantity-controls">
                                          <Tooltip
                                            title={
                                              product?.quantity == 1
                                                ? "Product count cannot be less than 1"
                                                : ""
                                            }
                                          >
                                            <Button
                                              shape="circle"
                                              size="small"
                                              icon={<MinusOutlined />}
                                              className={`border-radios-color-grey ${
                                                product?.quantity == 1 ||
                                                !isTermsRecordApproved
                                                  ? "disable-button "
                                                  : ""
                                              }`}
                                              onClick={() => {
                                                if (
                                                  (!restrictClick() &&
                                                    product?.quantity > 1) ||
                                                  !isTermsRecordApproved
                                                ) {
                                                  handleRemoveQuantity(product);
                                                }
                                              }}
                                            />
                                          </Tooltip>
                                          <span className="common-action-items-text-black-14">
                                            {product?.quantity || 1}
                                          </span>
                                          <Button
                                            shape="circle"
                                            size="small"
                                            icon={<PlusOutlined />}
                                            disabled={
                                              product?.quantity >=
                                                product?.available_quantity ||
                                              !isTermsRecordApproved
                                            }
                                            onClick={() =>
                                              handleAddQuantity(product)
                                            }
                                            className="border-radios-color-grey"
                                          />
                                        </div>
                                        <Text className="unit-quantitiy common-text-color-red-10">
                                          {product?.available_quantity == 0
                                            ? "Not Available"
                                            : `Up to ${product?.available_quantity} only`}{" "}
                                        </Text>
                                      </div>
                                    </>
                                  )}
                                </div>
                              </Col>
                            </Row>
                          </div>
                          <Row className="campaign-divider-row ">
                            <div className="campaign-divider-new" />
                          </Row>
                          <Row className="campaign-product-details-row">
                            <Col lg={6} xl={4}>
                              <span className="campaign-overview-header common-product-detail-text-grey-10">
                                {product?.type?.toLowerCase() === "media"
                                  ? "Length"
                                  : "Size"}
                              </span>
                              <Title className="billboard-values common-product-detail-text-black-12">
                                {product?.type?.toLowerCase() === "media" ? (
                                  <>{product?.length}</>
                                ) : (
                                  <>
                                    {formatSize(product?.height)} X{" "}
                                    {formatSize(product?.width)}
                                  </>
                                )}
                              </Title>

                              <span className="campaign-overview-header common-product-detail-text-grey-10">
                                Media Type
                              </span>
                              <Title className="billboard-values common-product-detail-text-black-12">
                                {" "}
                                {product?.type}
                              </Title>

                              <span className="campaign-overview-header common-product-detail-text-grey-10">
                                Selected Dates
                              </span>
                              <Title className="billboard-values common-product-detail-text-black-12">
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  {formatDate(product?.booked_from)}{" "}
                                  <Arrow
                                    className="campaign-icons campaign-overview-icons"
                                    style={{
                                      width: "16px",
                                      height: "16px",
                                    }}
                                  />
                                  {formatDate(product?.booked_to)}
                                </div>
                              </Title>
                            </Col>
                            <Col
                              lg={7}
                              xl={4}
                              className={`${isMobile ? "mobile-response-details-col" : ""}`}
                            >
                              <span className="campaign-overview-header common-product-detail-text-grey-10">
                                Impressions
                              </span>
                              <Title className="billboard-values common-product-detail-text-black-12">
                                {parseFloat(
                                  product?.impressionsperselectedDates || 0,
                                ).toFixed(2)}{" "}
                              </Title>

                              <span className="campaign-overview-header common-product-detail-text-grey-10">
                                CPM
                              </span>
                              <Title className="billboard-values common-product-detail-text-black-12">
                                {formatToUSCurrency(
                                  Number(product?.cpm)?.toFixed(2),
                                )}
                              </Title>

                              <span className="campaign-overview-header common-product-detail-text-grey-10">
                                Selected Days
                              </span>
                              <Title className="billboard-values common-product-detail-text-black-12">
                                {`${
                                  Math.floor(
                                    (new Date(product?.booked_to).setUTCHours(
                                      0,
                                      0,
                                      0,
                                      0,
                                    ) -
                                      new Date(
                                        product?.booked_from,
                                      ).setUTCHours(0, 0, 0, 0)) /
                                      (1000 * 60 * 60 * 24),
                                  ) + 1
                                } Days`}
                              </Title>
                            </Col>
                            {!isMobile ? (
                              <>
                                <Col lg={9} xl={4}>
                                  <span className="campaign-overview-header common-product-detail-text-grey-10">
                                    Product Price
                                  </span>
                                  <Title className="billboard-values common-product-detail-text-black-12">
                                    {formatToUSCurrency(
                                      parseFloat(product?.price || 0).toFixed(
                                        2,
                                      ),
                                    )}
                                  </Title>

                                  <span className="campaign-overview-header common-product-detail-text-grey-10">
                                    Tax (
                                    {parseFloat(product?.tax_percentage || 0)}
                                    %)
                                  </span>
                                  <Title className="billboard-values common-product-detail-text-black-12">
                                    $
                                    {parseFloat(
                                      product?.tax_percentage_amount || 0,
                                    ).toFixed(2)}
                                  </Title>

                                  <span className="campaign-overview-header common-product-detail-text-grey-10">
                                    Installation Fees + Production Price
                                  </span>
                                  <Title className="billboard-values common-product-detail-text-black-12">
                                    {`${formatToUSCurrency(
                                      parseFloat(
                                        product?.install_cost_price || 0,
                                      ).toFixed(2),
                                    )} + ${formatToUSCurrency(
                                      Number(
                                        product?.production_cost_price,
                                      ).toFixed(2),
                                    )}`}
                                  </Title>
                                </Col>
                              </>
                            ) : (
                              <>
                                <Row
                                  style={{
                                    width: "100%",
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "flex-end",
                                  }}
                                >
                                  <Col lg={7} xl={4}>
                                    <span className="campaign-overview-header common-product-detail-text-grey-10">
                                      Product Price
                                    </span>

                                    <Title className="billboard-values common-product-detail-text-black-12">
                                      {formatToUSCurrency(
                                        parseFloat(product?.price || 0).toFixed(
                                          2,
                                        ),
                                      )}
                                    </Title>
                                  </Col>

                                  <Col lg={7} xl={4}>
                                    <span className="campaign-overview-header common-product-detail-text-grey-10">
                                      Tax (
                                      {parseFloat(product?.tax_percentage || 0)}
                                      %)
                                    </span>

                                    <Title className="billboard-values common-product-detail-text-black-12">
                                      $
                                      {parseFloat(
                                        product?.tax_percentage_amount || 0,
                                      ).toFixed(2)}
                                    </Title>
                                  </Col>
                                </Row>
                                <Row>
                                  <Col lg={7} xl={4}>
                                    <span className="campaign-overview-header common-product-detail-text-grey-10">
                                      Installation Fees + Production Price
                                    </span>

                                    <Title className="billboard-values common-product-detail-text-black-12">
                                      {`${formatToUSCurrency(
                                        parseFloat(
                                          product?.install_cost_price || 0,
                                        ).toFixed(2),
                                      )} + ${formatToUSCurrency(
                                        Number(
                                          product?.production_cost_price || 0,
                                        ).toFixed(2),
                                      )}`}
                                    </Title>
                                  </Col>
                                </Row>
                              </>
                            )}
                          </Row>
                        </div>
                      </>
                    </div>
                  );
                })}
            </div>
          </>
        ) : (
          <div style={{ marginTop: "3rem" }}>
            <Row align="middle" justify="center">
              <Text className="produuct-nill-tag">
                No products have been added yet. Start building your campaign to
                make an impact!
              </Text>
            </Row>
            <Row align="middle" justify="center">
              {restrictClick() ? (
                <Tooltip title={getToolTipContent}>{addProductNowBtn}</Tooltip>
              ) : (
                <>{addProductNowBtn}</>
              )}
            </Row>
          </div>
        )}
        <ProductModalPopUp
          selectedTab={"recommonded"}
          contentName={"View Product"}
          setSelectedProduct={setSelectedProduct}
          productId={selectedProduct?.product_id}
          productFromDate={selectedProduct?.booked_from}
          productToDate={selectedProduct?.booked_to}
          isBillBoard={true}
        />
        <DeleteCamapign
          type={"deleteProduct"}
          setDeleteCampaignModal={setDeleteCampaignModal}
          deleteCampaignModal={deleteCampaignModal}
          deleteCampaignId={campaignId}
          productId={selectedProduct?.id}
          price={productPrice}
          selectedCampaignPage={false}
        />
        {isQuantityLoading && <Spin size="large" fullscreen />}
        <ReusableModal
          type={assetActionType}
          isActionModal={isActionModal}
          setIsActionModal={setIsActionModal}
          selectedChatProduct={selectedMoveProduct}
          campaignDetails={campaignInfo}
          campaignsPage={true}
        />
      </div>
    </>
  );
};

export default CampaignBillBoardsTable;
